import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="py-6 border-t border-gray-200">
        <div className="flex flex-wrap justify-center items-center gap-8">
          <div>
            <p className="text-xs text-gray-600">
              © 2026 InternHub. Your Internship Search Companion.
            </p>
          </div>
          {/* End Col */}

          {/* List */}
          <ul className="flex flex-wrap items-center">
            <li className="inline-block relative pe-4 text-xs last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:inset-e-1.5 before:-translate-y-1/2 before:size-[3px] before:rounded-full before:bg-gray-400">
              <Link
                className="text-xs text-gray-500 underline hover:text-gray-800 hover:decoration-2 focus:outline-hidden focus:decoration-2"
                to="/our-terms-of-service"
              >
                Terms of Service
              </Link>
            </li>
            <li className="inline-block relative pe-4 text-xs last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:inset-e-1.5 before:-translate-y-1/2 before:size-[3px] before:rounded-full before:bg-gray-400">
              <Link
                className="text-xs text-gray-500 underline hover:text-gray-800 hover:decoration-2 focus:outline-hidden focus:decoration-2"
                to="/our-privacy-policy"
              >
                Privacy Policy
              </Link>
            </li>
            <li className="inline-block relative pe-4 text-xs last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:inset-e-1.5 before:-translate-y-1/2 before:size-[3px] before:rounded-full before:bg-gray-400">
              <Link
                className="text-xs text-gray-500 underline hover:text-gray-800 hover:decoration-2 focus:outline-hidden focus:decoration-2"
                to="/our-cookie-policy"
              >
                Cookie Policy
              </Link>
            </li>
            <li className="inline-block relative pe-4 text-xs last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:inset-e-1.5 before:-translate-y-1/2 before:size-[3px] before:rounded-full before:bg-gray-400">
              <a
                className="text-xs text-gray-500 underline hover:text-gray-800 hover:decoration-2 focus:outline-hidden focus:decoration-2"
                href="mailto:support@internhubapp.com"
              >
                Support
              </a>
            </li>
          </ul>
          {/* End List */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
